import React, {Component} from 'react';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { ColorRing } from 'react-loader-spinner';
import PageTitle from "../../../components/common/PageTitle";
import FeatherIcon from 'feather-icons-react';
import { toast } from 'react-toastify';
import {
  Button,
  Col, Row,
  Modal, ModalBody, ModalHeader,
  FormInput, FormSelect,
  Badge,
} from "shards-react";

var RATING_TABS = [
  { key: 'high', label: '4~5점', min: 80, max: 100 },
  { key: 'mid', label: '3점', min: 60, max: 60 },
  { key: 'low', label: '1~2점', min: 20, max: 40 },
];

var EACH_STAR_TABS = [
  { key: 'star5', label: '★5', pt: 100 },
  { key: 'star4', label: '★4', pt: 80 },
  { key: 'star3', label: '★3', pt: 60 },
  { key: 'star2', label: '★2', pt: 40 },
  { key: 'star1', label: '★1', pt: 20 },
];

const TARGET_LABELS = {
  'default': '기본',
  'category': '카테고리',
  'product': '상품',
};

@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me: teamUser.me }))
@inject(({ common }) => ({ getStoreTotalConfig: common.getStoreTotalConfig, updateDoc: common.updateDoc }))
@inject(({ review }) => ({
  getQuickReviewPresetList: review.getQuickReviewPresetList,
  saveQuickReviewPreset: review.saveQuickReviewPreset,
  deleteQuickReviewPreset: review.deleteQuickReviewPreset,
}))

@observer
class QuickReviewConfig extends Component {

  @observable isLoading = true;
  @observable store = {};
  @observable teamUser = {};
  @observable basicSettings = {};

  // 설정
  @observable quickReviewConfig = {
    enableQuickReview: 'no',
    isQuickReviewOnly: false,
    minSelectCount: 1,
    maxSelectCount: 5,
  };

  // 프리셋 리스트
  @observable presetList = [];
  @observable activeTab = 'default'; // default, category, product
  @observable collapsedPresetIds = {};

  // 모달
  @observable isModalOpen = false;
  @observable editMode = 'create';
  @observable form = this.getEmptyForm();
  @observable newSentenceText = '';
  @observable newNegativeSentenceText = '';

  getEmptyForm() {
    return {
      _id: null,
      name: '',
      targetType: 'default',
      presetType: 'rating', // rating: 별점, proscons: 좋은점/나쁜점
      platformCateIds: [],
      product_ids: [],
      ratingRange: null,
      ratingRangeValue: '',
      sentences: [], // proscons용
      ratingTab: 'high',
      ratingSentences: { high: [], mid: [], low: [] },
      eachStarTab: 'star5',
      eachStarSentences: { star5: [], star4: [], star3: [], star2: [], star1: [] },
      isActive: true,
    };
  }

  componentDidMount() {
    this.init();
  }

  @action init = async () => {
    if (this.props.isLogin) {
      this.teamUser = this.props.me;
      this.store = this.teamUser.store;

      // BasicSettings 로드
      let config = await this.props.getStoreTotalConfig({
        store_id: this.teamUser.selStore_id,
        shopNo: this.teamUser.selShopNo || 1
      });
      if (config && config.basicSettings) {
        this.basicSettings = config.basicSettings;
        if (config.basicSettings.quickReviewConfig) {
          this.quickReviewConfig = {
            ...this.quickReviewConfig,
            ...config.basicSettings.quickReviewConfig,
          };
        }
      }

      await this.loadPresets();
      this.isLoading = false;
    }
  };

  @action loadPresets = async () => {
    let res = await this.props.getQuickReviewPresetList({
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      page: 1,
      limit: 200,
    });
    if (res && res.docs) {
      this.presetList = res.docs;
    }
  };

  @action saveConfig = async () => {
    let res = await this.props.updateDoc('updateBasicSettings', {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      quickReviewConfig: toJS(this.quickReviewConfig),
    });
    if (res) {
      toast.success('설정이 저장되었습니다.');
    } else {
      toast.error('저장에 실패했습니다.');
    }
  };

  @action openCreateModal = () => {
    this.form = this.getEmptyForm();
    this.form.targetType = this.activeTab;
    this.editMode = 'create';
    this.newSentenceText = '';
    this.newNegativeSentenceText = '';
    this.isModalOpen = true;
  };

  @action openEditModal = (preset) => {
    var ratingSentences = { high: [], mid: [], low: [] };
    var eachStarSentences = { star5: [], star4: [], star3: [], star2: [], star1: [] };
    var prosconseSentences = [];
    var allSentences = (preset.sentences || []).map(function(s, i) {
      return { text: s.text, type: s.type || 'positive', ratingKey: s.ratingKey || '', order: s.order || i, isActive: s.isActive !== false };
    });

    for (var i = 0; i < allSentences.length; i++) {
      var s = allSentences[i];
      if (s.ratingKey && eachStarSentences[s.ratingKey]) {
        eachStarSentences[s.ratingKey].push(s);
      } else if (s.ratingKey && ratingSentences[s.ratingKey]) {
        ratingSentences[s.ratingKey].push(s);
      } else {
        prosconseSentences.push(s);
      }
    }

    this.form = {
      _id: preset._id,
      name: preset.name || '',
      targetType: preset.targetType || 'default',
      presetType: preset.presetType || 'rating',
      platformCateIds: preset.platformCateIds || [],
      product_ids: preset.product_ids || [],
      ratingRange: null,
      ratingRangeValue: '',
      sentences: prosconseSentences,
      ratingTab: 'high',
      ratingSentences: ratingSentences,
      eachStarTab: 'star5',
      eachStarSentences: eachStarSentences,
      isActive: preset.isActive !== false,
    };
    this.editMode = 'edit';
    this.newSentenceText = '';
    this.newNegativeSentenceText = '';
    this.isModalOpen = true;
  };

  @action savePreset = async () => {
    if (!this.form.name) { toast.error('그룹명을 입력해주세요.'); return; }

    // 문장 합치기
    var allSentences = [];
    if (this.form.presetType === 'rating') {
      var rs = toJS(this.form.ratingSentences);
      for (var key in rs) {
        for (var i = 0; i < rs[key].length; i++) {
          allSentences.push({ text: rs[key][i].text, type: rs[key][i].type || 'positive', ratingKey: key, order: rs[key][i].order || i, isActive: rs[key][i].isActive !== false });
        }
      }
      if (allSentences.length === 0) { toast.error('문장을 최소 1개 이상 추가해주세요.'); return; }
    } else if (this.form.presetType === 'eachstar') {
      var es = toJS(this.form.eachStarSentences);
      for (var key2 in es) {
        for (var j = 0; j < es[key2].length; j++) {
          allSentences.push({ text: es[key2][j].text, type: 'positive', ratingKey: key2, order: es[key2][j].order || j, isActive: es[key2][j].isActive !== false });
        }
      }
      if (allSentences.length === 0) { toast.error('문장을 최소 1개 이상 추가해주세요.'); return; }
    } else {
      allSentences = toJS(this.form.sentences);
      if (allSentences.length === 0) { toast.error('문장을 최소 1개 이상 추가해주세요.'); return; }
    }

    let data = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo || 1,
      name: this.form.name,
      targetType: this.form.targetType,
      presetType: this.form.presetType,
      platformCateIds: toJS(this.form.platformCateIds),
      product_ids: toJS(this.form.product_ids),
      ratingRange: null,
      sentences: allSentences,
      isActive: this.form.isActive,
    };

    let params = { data: data };
    if (this.editMode === 'edit' && this.form._id) params.id = this.form._id;

    let res = await this.props.saveQuickReviewPreset(params);
    if (res && res.data) {
      toast.success(this.editMode === 'create' ? '문구 그룹이 생성되었습니다.' : '문구 그룹이 수정되었습니다.');
      this.isModalOpen = false;
      await this.loadPresets();
    } else {
      toast.error('저장에 실패했습니다.');
    }
  };

  @action deletePreset = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    let res = await this.props.deleteQuickReviewPreset({ id: id });
    if (res) {
      toast.success('삭제되었습니다.');
      await this.loadPresets();
    }
  };

  @action addSentence = (type) => {
    var text = type === 'negative' ? this.newNegativeSentenceText : this.newSentenceText;
    if (!text || !text.trim()) return;

    if (this.form.presetType === 'rating') {
      var tab = this.form.ratingTab;
      this.form.ratingSentences[tab].push({
        text: text.trim(), type: 'positive', ratingKey: tab,
        order: this.form.ratingSentences[tab].length, isActive: true,
      });
    } else if (this.form.presetType === 'eachstar') {
      var starTab = this.form.eachStarTab;
      this.form.eachStarSentences[starTab].push({
        text: text.trim(), type: 'positive', ratingKey: starTab,
        order: this.form.eachStarSentences[starTab].length, isActive: true,
      });
    } else {
      // proscons 타입: sentences에 추가
      this.form.sentences.push({
        text: text.trim(),
        type: type || 'positive',
        order: this.form.sentences.length,
        isActive: true,
      });
    }
    if (type === 'negative') { this.newNegativeSentenceText = ''; }
    else { this.newSentenceText = ''; }
  };

  getCurrentSentenceArr = () => {
    if (this.form.presetType === 'rating') return this.form.ratingSentences[this.form.ratingTab];
    if (this.form.presetType === 'eachstar') return this.form.eachStarSentences[this.form.eachStarTab];
    return this.form.sentences;
  };

  @action removeSentence = (idx) => {
    this.getCurrentSentenceArr().splice(idx, 1);
  };

  @action moveSentence = (idx, dir) => {
    var arr = this.getCurrentSentenceArr();
    var newIdx = idx + dir;
    if (newIdx < 0 || newIdx >= arr.length) return;
    var temp = arr[idx];
    arr[idx] = arr[newIdx];
    arr[newIdx] = temp;
  };

  @action switchRatingTab = (key) => {
    this.form.ratingTab = key;
    this.newSentenceText = '';
  };

  @action addCateId = (e) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      e.preventDefault();
      let val = e.target.value.trim();
      if (this.form.platformCateIds.indexOf(val) === -1) {
        this.form.platformCateIds.push(val);
      }
      e.target.value = '';
    }
  };

  @action removeCateId = (idx) => {
    this.form.platformCateIds.splice(idx, 1);
  };

  @action addProductId = (e) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      e.preventDefault();
      let val = e.target.value.trim();
      if (this.form.product_ids.indexOf(val) === -1) {
        this.form.product_ids.push(val);
      }
      e.target.value = '';
    }
  };

  @action removeProductId = (idx) => {
    this.form.product_ids.splice(idx, 1);
  };

  getFilteredPresets = () => {
    return this.presetList.filter(p => p.targetType === this.activeTab);
  };

  render() {
    if (this.isLoading) {
      return (
        <div className="text-center" style={{paddingTop: '100px'}}>
          <ColorRing visible={true} height="60" width="60" colors={['#5a6169','#5a6169','#5a6169','#5a6169','#5a6169']}/>
        </div>
      );
    }

    let filteredPresets = this.getFilteredPresets();
    const tabMeta = [
      {key: 'default', label: '기본 문구', icon: 'globe'},
      {key: 'category', label: '카테고리별', icon: 'tag'},
      {key: 'product', label: '상품별', icon: 'package'},
    ];

    return (
      <div className="main-content quick-review-config-page">
        <PageTitle />

        {/* === 상단: 기본 설정 (설문 페이지 스타일) === */}
        <div className="widget-box">
          <div className="section-box">
            <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16, padding: '16px 20px', borderBottom: '1px solid #F1F5F9'}}>
              <div style={{flex: 1}}>
                <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
                  <h3 style={{margin: 0, fontSize: 15, fontWeight: 700, color: '#1F2937'}}>간편 리뷰 기본 설정</h3>
                  <div style={{display: 'inline-flex', alignItems: 'center', gap: 6, padding: '2px 10px', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 100}}>
                    <span style={{fontSize: 12, color: '#6B7280'}}>간편 리뷰 사용</span>
                    <label className="src-switch">
                      <input type="checkbox"
                             aria-label="간편 리뷰 사용"
                             checked={this.quickReviewConfig.enableQuickReview === 'yes'}
                             onChange={e => {
                               this.quickReviewConfig.enableQuickReview = e.target.checked ? 'yes' : 'no';
                               this.saveConfig();
                             }}/>
                      <span className="src-switch__slider"/>
                    </label>
                  </div>
                </div>
                <p style={{margin: '6px 0 0', fontSize: 13, color: '#6B7280', lineHeight: 1.5}}>
                  리뷰 작성 폼에서 버튼/칩 형태로 자주 쓰는 문장을 빠르게 선택하도록 합니다.<br/>
                  대상별(기본/카테고리/상품)로 문구 그룹을 만들고, 별점범위·별점마다·좋은점/나쁜점 타입을 선택할 수 있습니다.
                </p>
              </div>
              <Button theme="primary" onClick={this.saveConfig} style={{flexShrink: 0}}>
                <FeatherIcon icon="save" size="14" style={{marginRight: 4}}/> 저장
              </Button>
            </div>
            <div style={{padding: '16px 20px'}}>
              <Row>
                <Col md="4">
                  <label style={{fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block'}}>간편 리뷰 모드</label>
                  <FormSelect value={this.quickReviewConfig.isQuickReviewOnly ? 'true' : 'false'} onChange={e => this.quickReviewConfig.isQuickReviewOnly = e.target.value === 'true'}>
                    <option value="false">병행 (텍스트 입력 가능)</option>
                    <option value="true">전용 (텍스트 입력 숨김)</option>
                  </FormSelect>
                </Col>
                <Col md="4">
                  <label style={{fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block'}}>최소 선택 수</label>
                  <FormInput type="number" min="1" value={this.quickReviewConfig.minSelectCount} onChange={e => this.quickReviewConfig.minSelectCount = parseInt(e.target.value) || 1}/>
                </Col>
                <Col md="4">
                  <label style={{fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6, display: 'block'}}>최대 선택 수</label>
                  <FormInput type="number" min="1" value={this.quickReviewConfig.maxSelectCount} onChange={e => this.quickReviewConfig.maxSelectCount = parseInt(e.target.value) || 5}/>
                </Col>
              </Row>
            </div>
          </div>
        </div>

        {/* === 탭 + 문구 그룹 관리 === */}
        <div className="widget-box">
          <div className="section-box">
            <div className="section-tit" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 20px', borderBottom: '1px solid #F1F5F9'}}>
              <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                {tabMeta.map(t => {
                  const active = this.activeTab === t.key;
                  return (
                    <button key={t.key}
                            type="button"
                            onClick={() => this.activeTab = t.key}
                            style={{
                              display: 'inline-flex', alignItems: 'center', gap: 6,
                              padding: '8px 14px', borderRadius: 8,
                              border: active ? '1px solid #4A6CF7' : '1px solid #E5E7EB',
                              background: active ? '#EEF2FF' : '#fff',
                              color: active ? '#4A6CF7' : '#6B7280',
                              fontWeight: active ? 700 : 500, fontSize: 13, cursor: 'pointer',
                              transition: 'all 150ms ease'
                            }}>
                      <FeatherIcon icon={t.icon} size="14"/> {t.label}
                    </button>
                  );
                })}
              </div>
              <Button theme="primary" onClick={this.openCreateModal} style={{display: 'inline-flex', alignItems: 'center', gap: 4}}>
                <FeatherIcon icon="plus" size="16"/> 문구 그룹 추가
              </Button>
            </div>

            <div style={{padding: '20px'}}>
              {filteredPresets.length === 0 ? (
                <div className="src-empty-state" style={{background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: 10}}>
                  <FeatherIcon icon="message-square" size="40"/>
                  <div className="src-empty-state__title">등록된 문구 그룹이 없습니다</div>
                  <div className="src-empty-state__desc">상단의 <b>문구 그룹 추가</b> 버튼을 눌러 새 그룹을 만들어 보세요.</div>
                </div>
              ) : (
                filteredPresets.map((preset, idx) => {
                  const typeLabel = preset.presetType === 'proscons' ? '좋은점/나쁜점' : preset.presetType === 'eachstar' ? '별점마다' : '별점범위';
                  const activeCount = (preset.sentences || []).filter(s => s.isActive).length;
                  const isCollapsed = !!this.collapsedPresetIds && this.collapsedPresetIds[preset._id];
                  return (
                    <div key={preset._id} className={`src-group-card ${preset.isActive ? 'is-active' : ''}`}>
                      <div className="src-group-card__head"
                           onClick={() => {
                             if (!this.collapsedPresetIds) this.collapsedPresetIds = {};
                             this.collapsedPresetIds[preset._id] = !isCollapsed;
                           }}>
                        <FeatherIcon icon="message-circle" size="16" style={{color: '#6B7280'}}/>
                        <div className="src-group-card__title-wrap">
                          <span className="src-group-card__title" title={preset.name}>{preset.name}</span>
                          <span className="src-status-badge src-status-badge--assigned" style={{background: preset.isActive ? '#D1FAE5' : '#F3F4F6', color: preset.isActive ? '#065F46' : '#6B7280'}}>
                            {preset.isActive ? '활성' : '비활성'}
                          </span>
                          <span className="src-chip" style={{background: preset.presetType === 'proscons' ? '#F5F3FF' : preset.presetType === 'eachstar' ? '#FEF3C7' : '#EEF2FF', color: preset.presetType === 'proscons' ? '#6D28D9' : preset.presetType === 'eachstar' ? '#92400E' : '#4A6CF7'}}>
                            {typeLabel}
                          </span>
                        </div>
                        <div className="src-group-card__summary" onClick={e => e.stopPropagation()}>
                          <span>문장 {activeCount}개</span>
                          {preset.targetType === 'category' && preset.platformCateIds && preset.platformCateIds.length > 0 && (
                            <span>· 카테고리 {preset.platformCateIds.length}개</span>
                          )}
                          {preset.targetType === 'product' && preset.product_ids && preset.product_ids.length > 0 && (
                            <span>· 상품 {preset.product_ids.length}개</span>
                          )}
                          <Button size="sm" theme="light" onClick={() => this.openEditModal(preset)}>
                            <FeatherIcon icon="edit-2" size="12"/> 수정
                          </Button>
                          <Button size="sm" theme="danger" onClick={() => this.deletePreset(preset._id)}>
                            <FeatherIcon icon="trash-2" size="12"/> 삭제
                          </Button>
                        </div>
                        <span className="src-group-card__toggle">
                          <FeatherIcon icon={isCollapsed ? 'chevron-down' : 'chevron-up'} size="16"/>
                        </span>
                      </div>
                      {!isCollapsed && (
                        <div className="src-group-card__body">
                          {(preset.sentences || []).length === 0 ? (
                            <div style={{fontSize: 12, color: '#9CA3AF'}}>등록된 문장이 없습니다.</div>
                          ) : (
                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 6}}>
                              {(preset.sentences || []).filter(s => s.isActive).map((s, si) => {
                                const isNeg = s.type === 'negative';
                                let ratingLabel = '';
                                if (s.ratingKey) {
                                  const rt = RATING_TABS.find(t => t.key === s.ratingKey) || EACH_STAR_TABS.find(t => t.key === s.ratingKey);
                                  ratingLabel = rt ? rt.label : '';
                                }
                                return (
                                  <span key={si} style={{
                                    display: 'inline-block', padding: '5px 12px', borderRadius: 20,
                                    backgroundColor: isNeg ? '#FEF2F2' : s.ratingKey ? '#EEF2FF' : '#F0FDF4',
                                    color: isNeg ? '#991B1B' : s.ratingKey ? '#4A6CF7' : '#166534',
                                    border: '1px solid ' + (isNeg ? '#FECACA' : s.ratingKey ? '#C7D2FE' : '#D1FAE5'),
                                    fontSize: 12, fontWeight: 500,
                                  }}>{ratingLabel ? '[' + ratingLabel + '] ' : ''}{s.text}</span>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>

        {/* ===== 생성/수정 모달 ===== */}
        <Modal open={this.isModalOpen} toggle={() => {}} size="lg" className="src-survey-list-modal">
          <ModalHeader toggle={() => this.isModalOpen = false}>
            {this.editMode === 'create' ? '문구 그룹 추가' : '문구 그룹 수정'}
            <Badge theme="info" style={{marginLeft: 8, fontSize: 11}}>{TARGET_LABELS[this.form.targetType]}</Badge>
            <small style={{display: 'block', fontSize: 12, color: '#6B7280', fontWeight: 400, marginTop: 2}}>
              그룹명·타입·문장을 입력하고 저장하세요. 타입에 따라 별점별 또는 좋은점/나쁜점으로 문장을 관리할 수 있습니다.
            </small>
          </ModalHeader>
          <ModalBody style={{padding: '20px 24px', maxHeight: '80vh', overflowY: 'auto'}}>

            <Row>
              <Col md="4">
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>그룹명</label>
                  <FormInput value={this.form.name} onChange={e => this.form.name = e.target.value} placeholder="예: 의류 기본 문구"/>
                </div>
              </Col>
              <Col md="4">
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>타입</label>
                  <FormSelect value={this.form.presetType} onChange={e => { var nt = e.target.value; var hasData = this.form.sentences.length > 0 || this.form.ratingSentences.high.length > 0 || this.form.ratingSentences.mid.length > 0 || this.form.ratingSentences.low.length > 0 || this.form.eachStarSentences.star5.length > 0 || this.form.eachStarSentences.star4.length > 0 || this.form.eachStarSentences.star3.length > 0 || this.form.eachStarSentences.star2.length > 0 || this.form.eachStarSentences.star1.length > 0; if (nt !== this.form.presetType && hasData && !window.confirm('타입을 변경하면 입력된 문장이 초기화됩니다.')) return; this.form.presetType = nt; this.form.sentences = []; this.form.ratingSentences = {high:[],mid:[],low:[]}; this.form.eachStarSentences = {star5:[],star4:[],star3:[],star2:[],star1:[]}; this.newSentenceText = ''; this.newNegativeSentenceText = ''; }}>
                    <option value="rating">별점범위</option>
                    <option value="eachstar">별점마다</option>
                    <option value="proscons">좋은점/나쁜점</option>
                  </FormSelect>
                </div>
              </Col>
              <Col md="4">
                <div style={{marginBottom: '16px'}}>
                  <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>상태</label>
                  <FormSelect value={this.form.isActive ? 'true' : 'false'} onChange={e => this.form.isActive = e.target.value === 'true'}>
                    <option value="true">활성</option>
                    <option value="false">비활성</option>
                  </FormSelect>
                </div>
              </Col>
            </Row>

            {/* 카테고리 입력 */}
            {this.form.targetType === 'category' && (
              <div style={{marginBottom: '16px'}}>
                <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>카테고리 ID (Enter로 추가)</label>
                <FormInput placeholder="카테고리 ID 입력 후 Enter" onKeyDown={e => this.addCateId(e)}/>
                <div style={{marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                  {this.form.platformCateIds.map((cid, i) => (
                    <span key={i} style={{display: 'inline-flex', alignItems: 'center', padding: '3px 10px', borderRadius: '12px', backgroundColor: '#e9ecef', fontSize: '12px'}}>
                      {cid}
                      <span style={{marginLeft: '6px', cursor: 'pointer', color: '#dc3545'}} onClick={() => this.removeCateId(i)}>x</span>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* 상품 ID 입력 */}
            {this.form.targetType === 'product' && (
              <div style={{marginBottom: '16px'}}>
                <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '6px', display: 'block'}}>상품 ID (Enter로 추가)</label>
                <FormInput placeholder="상품 platformProductId 입력 후 Enter" onKeyDown={e => this.addProductId(e)}/>
                <div style={{marginTop: '6px', display: 'flex', flexWrap: 'wrap', gap: '4px'}}>
                  {this.form.product_ids.map((pid, i) => (
                    <span key={i} style={{display: 'inline-flex', alignItems: 'center', padding: '3px 10px', borderRadius: '12px', backgroundColor: '#e9ecef', fontSize: '12px'}}>
                      {pid}
                      <span style={{marginLeft: '6px', cursor: 'pointer', color: '#dc3545'}} onClick={() => this.removeProductId(i)}>x</span>
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* 문장 관리 */}
            {this.form.presetType === 'proscons' ? (
              /* ===== 좋은점/나쁜점 2컬럼 ===== */
              <div style={{marginBottom: '16px'}}>
                <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '10px', display: 'block'}}>리뷰 문장 ({this.form.sentences.length}개)</label>
                <div style={{display: 'flex', gap: '16px'}}>
                  <div style={{flex: 1}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px'}}>
                      <span style={{display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#10b981'}}></span>
                      <span style={{fontSize: '13px', fontWeight: '600', color: '#10b981'}}>좋은점</span>
                      <span style={{fontSize: '11px', color: '#adb5bd'}}>({this.form.sentences.filter(function(s){return s.type !== 'negative';}).length})</span>
                    </div>
                    <div style={{display: 'flex', gap: '6px', marginBottom: '10px'}}>
                      <FormInput value={this.newSentenceText} onChange={e => this.newSentenceText = e.target.value} placeholder="예: 품질이 좋아요" onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.addSentence('positive'); } }} style={{flex: 1, fontSize: '12px'}}/>
                      <Button theme="success" size="sm" onClick={() => this.addSentence('positive')} style={{whiteSpace: 'nowrap', fontSize: '11px'}}><FeatherIcon icon="plus" size="12"/> 추가</Button>
                    </div>
                    <div style={{border: '1px solid #d1fae5', borderRadius: '8px', maxHeight: '250px', overflowY: 'auto', backgroundColor: '#f0fdf4'}}>
                      {this.form.sentences.filter(function(s){return s.type !== 'negative';}).length === 0 ? (
                        <div style={{padding: '16px', textAlign: 'center', color: '#adb5bd', fontSize: '12px'}}>좋은점 문장을 추가해주세요</div>
                      ) : this.form.sentences.map((sentence, idx) => {
                        if (sentence.type === 'negative') return null;
                        return (<div key={idx} style={{display: 'flex', alignItems: 'center', padding: '6px 10px', borderBottom: '1px solid #d1fae5'}}>
                          <span style={{flex: 1, padding: '4px 10px', borderRadius: '14px', backgroundColor: '#dcfce7', color: '#166534', fontSize: '12px', fontWeight: '500'}}>{sentence.text}</span>
                          <div style={{display: 'flex', gap: '2px', marginLeft: '6px'}}>
                            <Button size="sm" theme="light" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.moveSentence(idx, -1)}><FeatherIcon icon="arrow-up" size="10"/></Button>
                            <Button size="sm" theme="light" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.moveSentence(idx, 1)}><FeatherIcon icon="arrow-down" size="10"/></Button>
                            <Button size="sm" theme="danger" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.removeSentence(idx)}><FeatherIcon icon="x" size="10"/></Button>
                          </div>
                        </div>);
                      })}
                    </div>
                  </div>
                  <div style={{flex: 1}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px'}}>
                      <span style={{display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#ef4444'}}></span>
                      <span style={{fontSize: '13px', fontWeight: '600', color: '#ef4444'}}>나쁜점</span>
                      <span style={{fontSize: '11px', color: '#adb5bd'}}>({this.form.sentences.filter(function(s){return s.type === 'negative';}).length})</span>
                    </div>
                    <div style={{display: 'flex', gap: '6px', marginBottom: '10px'}}>
                      <FormInput value={this.newNegativeSentenceText} onChange={e => this.newNegativeSentenceText = e.target.value} placeholder="예: 배송이 느려요" onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.addSentence('negative'); } }} style={{flex: 1, fontSize: '12px'}}/>
                      <Button theme="danger" size="sm" onClick={() => this.addSentence('negative')} style={{whiteSpace: 'nowrap', fontSize: '11px'}}><FeatherIcon icon="plus" size="12"/> 추가</Button>
                    </div>
                    <div style={{border: '1px solid #fecaca', borderRadius: '8px', maxHeight: '250px', overflowY: 'auto', backgroundColor: '#fef2f2'}}>
                      {this.form.sentences.filter(function(s){return s.type === 'negative';}).length === 0 ? (
                        <div style={{padding: '16px', textAlign: 'center', color: '#adb5bd', fontSize: '12px'}}>나쁜점 문장을 추가해주세요</div>
                      ) : this.form.sentences.map((sentence, idx) => {
                        if (sentence.type !== 'negative') return null;
                        return (<div key={idx} style={{display: 'flex', alignItems: 'center', padding: '6px 10px', borderBottom: '1px solid #fecaca'}}>
                          <span style={{flex: 1, padding: '4px 10px', borderRadius: '14px', backgroundColor: '#fee2e2', color: '#991b1b', fontSize: '12px', fontWeight: '500'}}>{sentence.text}</span>
                          <div style={{display: 'flex', gap: '2px', marginLeft: '6px'}}>
                            <Button size="sm" theme="light" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.moveSentence(idx, -1)}><FeatherIcon icon="arrow-up" size="10"/></Button>
                            <Button size="sm" theme="light" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.moveSentence(idx, 1)}><FeatherIcon icon="arrow-down" size="10"/></Button>
                            <Button size="sm" theme="danger" style={{padding: '1px 4px', fontSize: '9px'}} onClick={() => this.removeSentence(idx)}><FeatherIcon icon="x" size="10"/></Button>
                          </div>
                        </div>);
                      })}
                    </div>
                  </div>
                </div>
              </div>
            ) : this.form.presetType === 'eachstar' ? (
              /* ===== 별점마다 타입: 5탭 문장 관리 ===== */
              <div style={{marginBottom: '16px'}}>
                <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '10px', display: 'block'}}>
                  별점마다 리뷰 문장
                  <span style={{fontSize: '11px', fontWeight: '400', color: '#adb5bd', marginLeft: '8px'}}>
                    ({EACH_STAR_TABS.map((t) => t.label + ':' + this.form.eachStarSentences[t.key].length).join(' / ')})
                  </span>
                </label>
                <div style={{display: 'flex', gap: '0', marginBottom: '12px'}}>
                  {EACH_STAR_TABS.map((tab) => (
                    <button key={tab.key} type="button" onClick={() => { this.form.eachStarTab = tab.key; this.newSentenceText = ''; }} style={{
                      flex: 1, padding: '10px', border: '1px solid #dee2e6', borderBottom: this.form.eachStarTab === tab.key ? '2px solid #f59e0b' : '1px solid #dee2e6',
                      backgroundColor: this.form.eachStarTab === tab.key ? '#fff' : '#f8f9fc',
                      color: this.form.eachStarTab === tab.key ? '#f59e0b' : '#868e96',
                      fontWeight: this.form.eachStarTab === tab.key ? '700' : '500',
                      fontSize: '13px', cursor: 'pointer', transition: 'all 0.15s',
                      borderRadius: tab.key === 'star5' ? '8px 0 0 0' : tab.key === 'star1' ? '0 8px 0 0' : '0',
                    }}>
                      {tab.label}
                      {this.form.eachStarSentences[tab.key].length > 0 && (
                        <span style={{marginLeft: '4px', fontSize: '11px', color: '#f59e0b'}}>({this.form.eachStarSentences[tab.key].length})</span>
                      )}
                    </button>
                  ))}
                </div>
                <div style={{display: 'flex', gap: '8px', marginBottom: '12px'}}>
                  <FormInput
                    value={this.newSentenceText}
                    onChange={e => this.newSentenceText = e.target.value}
                    placeholder={'예: ' + (this.form.eachStarTab === 'star5' ? '최고예요!' : this.form.eachStarTab === 'star4' ? '좋아요' : this.form.eachStarTab === 'star3' ? '보통이에요' : this.form.eachStarTab === 'star2' ? '아쉬워요' : '별로예요')}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.addSentence('positive'); } }}
                    style={{flex: 1}}
                  />
                  <Button theme="warning" onClick={() => this.addSentence('positive')} style={{whiteSpace: 'nowrap'}}>
                    <FeatherIcon icon="plus" size="14"/> 추가
                  </Button>
                </div>
                <div style={{border: '1px solid #e9ecef', borderRadius: '0 0 8px 8px', maxHeight: '250px', overflowY: 'auto'}}>
                  {this.form.eachStarSentences[this.form.eachStarTab].length === 0 ? (
                    <div style={{padding: '20px', textAlign: 'center', color: '#adb5bd', fontSize: '13px'}}>
                      {(function(){ var t = EACH_STAR_TABS.find(function(x){ return x.key === this.form.eachStarTab; }.bind(this)); return t ? t.label : ''; }.bind(this))()} 리뷰 문장을 추가해주세요
                    </div>
                  ) : this.form.eachStarSentences[this.form.eachStarTab].map((sentence, idx) => (
                    <div key={idx} style={{
                      display: 'flex', alignItems: 'center', padding: '8px 12px',
                      borderBottom: idx < this.form.eachStarSentences[this.form.eachStarTab].length - 1 ? '1px solid #f0f0f0' : 'none',
                      backgroundColor: idx % 2 === 0 ? '#fff' : '#fafbfc',
                    }}>
                      <span style={{fontSize: '12px', color: '#adb5bd', width: '24px'}}>{idx + 1}</span>
                      <span style={{flex: 1, padding: '4px 10px', borderRadius: '16px', backgroundColor: '#fef3c7', color: '#92400e', fontSize: '13px', fontWeight: '500'}}>{sentence.text}</span>
                      <div style={{display: 'flex', gap: '4px', marginLeft: '8px'}}>
                        <Button size="sm" theme="light" style={{padding: '2px 6px', fontSize: '10px'}} disabled={idx === 0} onClick={() => this.moveSentence(idx, -1)}><FeatherIcon icon="arrow-up" size="12"/></Button>
                        <Button size="sm" theme="light" style={{padding: '2px 6px', fontSize: '10px'}} disabled={idx === this.form.eachStarSentences[this.form.eachStarTab].length - 1} onClick={() => this.moveSentence(idx, 1)}><FeatherIcon icon="arrow-down" size="12"/></Button>
                        <Button size="sm" theme="danger" style={{padding: '2px 6px', fontSize: '10px'}} onClick={() => this.removeSentence(idx)}><FeatherIcon icon="x" size="12"/></Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              /* ===== 별점범위 타입: 탭 기반 문장 관리 ===== */
              <div style={{marginBottom: '16px'}}>
                <label style={{fontSize: '13px', fontWeight: '600', color: '#495057', marginBottom: '10px', display: 'block'}}>
                  별점별 리뷰 문장
                  <span style={{fontSize: '11px', fontWeight: '400', color: '#adb5bd', marginLeft: '8px'}}>
                    (4~5점: {this.form.ratingSentences.high.length}개 / 3점: {this.form.ratingSentences.mid.length}개 / 1~2점: {this.form.ratingSentences.low.length}개)
                  </span>
                </label>

                {/* 별점 탭 */}
                <div style={{display: 'flex', gap: '0', marginBottom: '12px'}}>
                  {RATING_TABS.map((tab) => (
                    <button key={tab.key} type="button" onClick={() => this.switchRatingTab(tab.key)} style={{
                      flex: 1, padding: '10px', border: '1px solid #dee2e6', borderBottom: this.form.ratingTab === tab.key ? '2px solid #5664D2' : '1px solid #dee2e6',
                      backgroundColor: this.form.ratingTab === tab.key ? '#fff' : '#f8f9fc',
                      color: this.form.ratingTab === tab.key ? '#5664D2' : '#868e96',
                      fontWeight: this.form.ratingTab === tab.key ? '700' : '500',
                      fontSize: '13px', cursor: 'pointer', transition: 'all 0.15s',
                      borderRadius: tab.key === 'high' ? '8px 0 0 0' : tab.key === 'low' ? '0 8px 0 0' : '0',
                    }}>
                      {tab.label}
                      {this.form.ratingSentences[tab.key].length > 0 && (
                        <span style={{marginLeft: '4px', fontSize: '11px', color: '#5664D2'}}>({this.form.ratingSentences[tab.key].length})</span>
                      )}
                    </button>
                  ))}
                </div>

                {/* 현재 탭의 문장 입력 */}
                <div style={{display: 'flex', gap: '8px', marginBottom: '12px'}}>
                  <FormInput
                    value={this.newSentenceText}
                    onChange={e => this.newSentenceText = e.target.value}
                    placeholder={'예: ' + (this.form.ratingTab === 'high' ? '최고예요, 재구매 의향 있어요' : this.form.ratingTab === 'mid' ? '보통이에요, 가격대비 괜찮아요' : '기대에 못 미쳐요, 개선이 필요해요')}
                    onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.addSentence('positive'); } }}
                    style={{flex: 1}}
                  />
                  <Button theme="info" onClick={() => this.addSentence('positive')} style={{whiteSpace: 'nowrap'}}>
                    <FeatherIcon icon="plus" size="14"/> 추가
                  </Button>
                </div>

                {/* 현재 탭의 문장 리스트 */}
                <div style={{border: '1px solid #e9ecef', borderRadius: '0 0 8px 8px', maxHeight: '250px', overflowY: 'auto'}}>
                  {this.form.ratingSentences[this.form.ratingTab].length === 0 ? (
                    <div style={{padding: '20px', textAlign: 'center', color: '#adb5bd', fontSize: '13px'}}>
                      {(function(){ var t = RATING_TABS.find(function(x){ return x.key === this.form.ratingTab; }.bind(this)); return t ? t.label : ''; }.bind(this))()} 리뷰 문장을 추가해주세요
                    </div>
                  ) : this.form.ratingSentences[this.form.ratingTab].map((sentence, idx) => (
                    <div key={idx} style={{
                      display: 'flex', alignItems: 'center', padding: '8px 12px',
                      borderBottom: idx < this.form.ratingSentences[this.form.ratingTab].length - 1 ? '1px solid #f0f0f0' : 'none',
                      backgroundColor: idx % 2 === 0 ? '#fff' : '#fafbfc',
                    }}>
                      <span style={{fontSize: '12px', color: '#adb5bd', width: '24px'}}>{idx + 1}</span>
                      <span style={{flex: 1, padding: '4px 10px', borderRadius: '16px', backgroundColor: '#eef2ff', color: '#5664D2', fontSize: '13px', fontWeight: '500'}}>{sentence.text}</span>
                      <div style={{display: 'flex', gap: '4px', marginLeft: '8px'}}>
                        <Button size="sm" theme="light" style={{padding: '2px 6px', fontSize: '10px'}} disabled={idx === 0} onClick={() => this.moveSentence(idx, -1)}><FeatherIcon icon="arrow-up" size="12"/></Button>
                        <Button size="sm" theme="light" style={{padding: '2px 6px', fontSize: '10px'}} disabled={idx === this.form.ratingSentences[this.form.ratingTab].length - 1} onClick={() => this.moveSentence(idx, 1)}><FeatherIcon icon="arrow-down" size="12"/></Button>
                        <Button size="sm" theme="danger" style={{padding: '2px 6px', fontSize: '10px'}} onClick={() => this.removeSentence(idx)}><FeatherIcon icon="x" size="12"/></Button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </ModalBody>
          <div style={{display: 'flex', justifyContent: 'flex-end', padding: '12px 24px', borderTop: '1px solid #E5E7EB', gap: 8}}>
            <Button theme="light" onClick={() => this.isModalOpen = false}>취소</Button>
            <Button theme="primary" onClick={this.savePreset}>
              <FeatherIcon icon="save" size="14" style={{marginRight: 4}}/> 저장
            </Button>
          </div>
        </Modal>

      </div>
    );
  }
}

export default QuickReviewConfig;
